<template>

  <div class="service__request sr__listPage">
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Service Requests
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left booking_content_wrapper mb-2"
        cols="12"
        md="12"
        style="display: flex; flex-direction: column;"
      >
        <b-col
          class="content-header-right mb-2 ml-auto"
          cols="12"
          md="12"
        >
          <div style="display: flex;">
            <div class="date__picker_block white-bg-dp mr-2">
              <b-form-group
                label=""
              >
                <b-input-group>
                  <flat-pickr
                    id="main-date"
                    v-model="parentServiceDate"
                    class="form-control"
                    placeholder="Select Date"
                    :config="flatPickrConfig"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      icon="CalendarIcon"
                      class="cursor-pointer"
                      data-toggle
                      size="18"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <b-button
              variant="success"
              :to="{ name: 'operation-service-requests-create' }"
              class="mobile_create_button"
              style="height: 40px;"
              :style="[ isMobile() ? { 'top' : '0' } : '']"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
                size="16"
              />
              <span class="align-middle d-md-block d-none">Create New Service Request</span>
              <span class="align-middle d-md-none d-block">New</span>
            </b-button>
          </div>
        </b-col>
        <b-dropdown
          v-if="isMobile()"
          :text="currentTabTitle"
          variant="outline-primary"
          class="mt-5"
          style="width: 200px;"
        >
          <b-dropdown-item
            v-for="(tab, index) in pageTabs"
            :key="index"
            @click="changeRoute(tab.param)"
          >
            {{ tab.title }} ({{ tab.count }})
          </b-dropdown-item>
        </b-dropdown>
        <b-tabs
          pills
          class="booking__content"
          :nav-class="[isMobile() ? 'd-none' : '']"
        >
          <!-- Tab: Information -->
          <b-tab
            :active="$route.params.type == 'pending'"
            lazy
            @click="changeRoute('pending')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Pending <span class="rounded-number">{{ pendingCount }}</span></span>
            </template>
            <open-service-request
              class="mt-2 pt-75"
              :parent-service-date.sync="parentServiceDate"
              :request-type-options="requestTypeOptions"
              :assignee-options="assigneeOptions"
              @emitCountServiceRequest="countServiceRequests"
            />
          </b-tab>

          <b-tab
            :active="$route.params.type == 'completed'"
            lazy
            @click="changeRoute('completed')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Completed <span class="rounded-number">{{ completedCount }}</span></span>
            </template>
            <completed-service-request
              class="mt-2 pt-75"
              :parent-service-date.sync="parentServiceDate"
              :request-type-options="requestTypeOptions"
              :assignee-options="assigneeOptions"
              @emitCountServiceRequest="countServiceRequests"
            />
          </b-tab>

          <b-tab
            :active="$route.params.type == 'unassigned'"
            lazy
            @click="changeRoute('unassigned')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Unassigned <span class="rounded-number">{{ unassignedCount }}</span></span>
            </template>
            <unassigned-service-request
              class="mt-2 pt-75"
              :parent-service-date.sync="parentServiceDate"
              :request-type-options="requestTypeOptions"
              :assignee-options="assigneeOptions"
              @emitCountServiceRequest="countServiceRequests"
            />
          </b-tab>

          <b-tab
            :active="$route.params.type == 'my-requests'"
            lazy
            @click="changeRoute('my-requests')"
          >
            <template #title>
              <span class="d-none d-sm-inline">Assigned To Me <span class="rounded-number">{{ myRequestsCount }}</span></span>
            </template>
            <my-service-request
              class="mt-2 pt-75"
              :parent-service-date.sync="parentServiceDate"
              :request-type-options="requestTypeOptions"
              :assignee-options="assigneeOptions"
              @emitCountServiceRequest="countServiceRequests"
            />
          </b-tab>

          <b-tab
            :active="$route.params.type == 'all-service-requests'"
            lazy
            @click="changeRoute('all-service-requests')"
          >
            <template #title>
              <span class="d-none d-sm-inline">All Service Requests <span class="rounded-number">{{ allCount }}</span></span>
            </template>
            <all-service-request
              class="mt-2 pt-75"
              :parent-service-date.sync="parentServiceDate"
              :request-type-options="requestTypeOptions"
              :assignee-options="assigneeOptions"
              @emitCountServiceRequest="countServiceRequests"
            />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BButton, BCol, BTab, BTabs, BDropdown, BDropdownItem, BFormGroup, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AllServiceRequest from './all-service-request/AllServiceRequest.vue'
import CompletedServiceRequest from './completed-service-request/CompletedServiceRequest.vue'
import OpenServiceRequest from './open-service-request/OpenServiceRequest.vue'
import UnassignedServiceRequest from './unassigned-service-request/UnassignedServiceRequest.vue'
import MyServiceRequest from './my-service-request/MyServiceRequest.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTab,
    BTabs,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,

    flatPickr,

    AllServiceRequest,
    OpenServiceRequest,
    CompletedServiceRequest,
    UnassignedServiceRequest,
    MyServiceRequest,
  },
  data() {
    return {
      parentServiceDate: this.$route.query.serviceDate || '',
      allCount: 0,
      pendingCount: 0,
      completedCount: 0,
      unassignedCount: 0,
      myRequestsCount: 0,
      requestTypeOptions: [],
      assigneeOptions: [],
      currentTabTitle: '',
      pageTabs: [
        {
          title: 'Pending',
          param: 'pending',
          count: 0,
        },
        {
          title: 'Completed',
          param: 'completed',
          count: 0,
        },
        {
          title: 'Unassigned',
          param: 'unassigned',
          count: 0,
        },
        {
          title: 'Assigned To Me',
          param: 'my-requests',
          count: 0,
        },
        {
          title: 'All Service Requests',
          param: 'all-service-requests',
          count: 0,
        },
      ],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, disableMobile: true,
      },
    }
  },
  watch: {
    $route() {
      const param = this.$route.params.type
      const currentTab = this.pageTabs.find(o => o.param === param)
      if (currentTab) {
        this.currentTabTitle = `${currentTab.title} (${currentTab.count})`
      }
    },
  },
  beforeMount() {
    this.countServiceRequests()
    this.$http.get('operation/service-forms/respond-with/duty-officers-workflow', { params: { department: true } })
      .then(response => {
        const workFlowCats = response.data.workFlowCats ?? []
        this.assigneeOptions = response.data.dutyOfficers ?? []

        workFlowCats.forEach(element => {
          this.requestTypeOptions.push({
            category: element.name,
            name: null,

            _id: element._id,
          })
          element.workFlows.forEach(flow => {
            this.requestTypeOptions.push({
              name: flow.name,

              _id: flow._id,
            })
          })
        })
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },

  methods: {
    changeRoute(param) {
      this.$router.replace({
        params: {
          type: param,
        },
        query: {},
      })
    },
    countServiceRequests() {
      this.$http.get('operation/service-requests/counts')
        .then(response => {
          this.allCount = response.data.allCount
          this.pendingCount = response.data.pendingCount
          this.completedCount = response.data.completedCount
          this.unassignedCount = response.data.unassignedCount
          this.myRequestsCount = response.data.myRequestsCount

          this.pageTabs.forEach(element => {
            if (element.title === 'All Service Requests') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.allCount
            } else if (element.title === 'Completed') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.completedCount
            } else if (element.title === 'Pending') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.pendingCount
            } else if (element.title === 'Unassigned') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.unassignedCount
            } else if (element.title === 'Assigned To Me') {
              // eslint-disable-next-line no-param-reassign
              element.count = this.myRequestsCount
            }
          })

          const param = this.$route.params.type

          const currentTab = this.pageTabs.find(o => o.param === param)
          if (currentTab) {
            this.currentTabTitle = `${currentTab.title} (${currentTab.count})`
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>

<style scoped>
  .rounded-number {
    height: 24px;
    width: 24px;
    background-color: #FFFFFF;
    border-radius: 50%;
    color:#104D9D;
  }
</style>
